import axios from "axios";

const uploadImageToS3 = async ({ blob, token }) => {
  const serverURL = process.env.REACT_APP_URL;
  if (!blob) return null;

  try {
    const formData = new FormData();
    formData.append("files", blob);

    const response = await axios.post(`${serverURL}/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data?.data?.[0] || null;
  } catch (error) {
    console.error("Upload failed", error);
    return null;
  }
};

export default uploadImageToS3;
